import { useState, useCallback } from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'

import { BASE_URL } from './constants'

import MainPage from './pages/MainPage'
import HazardsPage from './pages/HazardsPage'
import DetailsPage from './pages/DetailsPage'

import { ScrollToTop } from './pages/util'

function App() {
  const [acceptedDisclaimer, setAcceptedDisclaimer] = useState(false)

  const acceptDisclaimer = useCallback(() => setAcceptedDisclaimer(true), [])
  const declineDisclaimer = useCallback(() => { window.location = 'https://www.horrycountysc.gov'; }, [])

  return (
    <Router basename={BASE_URL}>
      <Switch>
        <Route path="/flood-info">
          <HazardsPage acceptDisclaimer={acceptDisclaimer} acceptedDisclaimer={acceptedDisclaimer} declineDisclaimer={declineDisclaimer} />
        </Route>
        <Route path="/details/:pin">
          <DetailsPage acceptDisclaimer={acceptDisclaimer} acceptedDisclaimer={acceptedDisclaimer} declineDisclaimer={declineDisclaimer} />
        </Route>
        <Route exact path="/" render={(props) => <MainPage acceptDisclaimer={acceptDisclaimer} acceptedDisclaimer={acceptedDisclaimer} declineDisclaimer={declineDisclaimer} {...props} />} />
      </Switch>
      <ScrollToTop />
    </Router>
  );
}

export default App;
